import {
  B2C_ONBOARDING_PAGES,
  SERVICE_BASIC_CARE,
  SERVICE_BASIC_MEDICAL_CARE,
  SOLUTION_HELP_AT_HOME,
  TRACK_EVENTS,
} from "core/consts";
import Tile, { TILETYPE } from "ds_legacy/components/TileButton";
import {
  USER_FILTER_SERVICES,
  USER_FILTER_SOLUTIONS,
} from "dsl/organisms/Filters/consts";
import { BedIcon, HomeIcon } from "lucide-react";
import { useTracking } from "react-tracking";
import OnboardingCard, { PageProps, StyledCaption, testIds } from "../common";
import { TERM_CHOICES } from "./Term";

const AT_HOME = "at home";
const CARE_HOME = "care home";

export default function CareType({
  navigateToPage,
  setFilters,
  translations,
}: PageProps) {
  const { trackEvent } = useTracking();

  const gotoNext = (target?: typeof AT_HOME | typeof CARE_HOME) => {
    if (!target) {
      navigateToPage(B2C_ONBOARDING_PAGES.LOCATION);
      setFilters({
        type: USER_FILTER_SOLUTIONS,
        value: [SOLUTION_HELP_AT_HOME, ...TERM_CHOICES],
      });
      setFilters({
        type: USER_FILTER_SERVICES,
        value: [SERVICE_BASIC_CARE, SERVICE_BASIC_MEDICAL_CARE],
      });
    } else {
      navigateToPage(
        target === CARE_HOME
          ? B2C_ONBOARDING_PAGES.CARE_TERM
          : B2C_ONBOARDING_PAGES.CARE_SOLUTION,
      );
    }
    trackEvent({
      name: TRACK_EVENTS.DASHBOARD_FILTERS,
      search_target: target,
    });
  };
  return (
    <OnboardingCard
      data-testid={testIds.careType}
      navigateToPage={navigateToPage}
      title={translations.bToC.onboardingScreens.titleWhichCare}
      onNext={gotoNext}
    >
      <StyledCaption>
        {translations.bToC.onboardingScreens.yourChoice}:
      </StyledCaption>
      <Tile
        Icon={BedIcon}
        label={translations.bToC.onboardingScreens.buttonCareHome}
        tileType={TILETYPE.B2C}
        onClick={() => gotoNext(CARE_HOME)}
      />
      <Tile
        Icon={HomeIcon}
        label={translations.bToC.onboardingScreens.buttonAtHome}
        tileType={TILETYPE.B2C}
        onClick={() => gotoNext(AT_HOME)}
      />
    </OnboardingCard>
  );
}
